import React from 'react'
import { useParams } from 'react-router-dom'
import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb'
import {
  IndexAdditionalInfoSVG,
  IndexAdditionalInfoSection,
} from 'src/components/Reusable/IndexPage/IndexPage.styles'
import { DirectRoutes } from 'src/components/Reusable/RootPage/RootPage.constants'
import { dateWithinWindow, formatTimestamp } from 'src/Utils/formatDate'
import { DateLimitWarningContainer } from '../Roadmap_v2/roadmap.styles'
import { DATE_LIMIT_WARNING } from '../Roadmap_v2/roadmap.constants'
import {
  AccountSettingsLink,
  DateLimitInfoContainer,
} from './AccountSettings.styles'

export const DateLimitInfoSection = ({
  dateLimit,
  onClickHandler,
}: {
  dateLimit: Timestamp
  onClickHandler?: () => void
}): JSX.Element => {
  const { pageContext } = useParams()
  const settingsLink = `/${pageContext}/${DirectRoutes.ACCOUNT_SETTINGS}`
  const isOldDateLimit = !dateWithinWindow(dateLimit, 365)

  return (
    <DateLimitInfoContainer>
      <IndexAdditionalInfoSection>
        <IndexAdditionalInfoSVG />
        Considering evidence since&nbsp;
        {formatTimestamp(dateLimit)}.
        {isOldDateLimit && (
          <DateLimitWarningContainer>
            &nbsp;{DATE_LIMIT_WARNING}
          </DateLimitWarningContainer>
        )}
      </IndexAdditionalInfoSection>
      <AccountSettingsLink to={settingsLink} onClick={onClickHandler}>
        Change in settings
      </AccountSettingsLink>
    </DateLimitInfoContainer>
  )
}
